import styled from "styled-components";

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`;

export const ContentWithPdf = styled.div`
  flex: 1;
  height: 100%;
  overflow: hidden;
`;

export const PdfContainer = styled.div`
  flex: 1;
  background: white;
  border: 1px solid #e5e7eb;
  padding: 20px;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;

export const PdfFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

export const EmptyState = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  height: 100%;
`;

export const EmptyContent = styled.div`
  text-align: center;
  color: #6b7280;
`;

export const EmptyIcon = styled.div`
  margin: 0 auto 16px auto;
  color: #d1d5db;
`;

export const EmptyText = styled.p`
  font-size: 18px;
  margin: 0;
`;
